<template>
  <div :class="{ opened: visible, 'bg-secondary_x_light': visible, 'cycle-status__wrapper': true }">
    <div class="px-3 py-2">
      <CRow class="w-100 align-items-center">
        <CCol col="4">
          <div
            class="card-collapse d-flex align-items-center gap-3 ml-2 pointer"
            data-cy="collapse-toggle"
          >
            <Icon :name="visible ? 'chevron-up' : 'chevron-down'" :key="visible" @click.prevent="visible = !visible" />
            <Text :size="visible ? 'p5' : 'p6'">
              <CLink :to="{name: 'Cycle Details', params: {...$route.params, cycle: cycle}}" style="color: inherit; text-decoration: none">
                {{ title }}
              </CLink>
            </Text>
          </div>
        </CCol>
        <CCol col="3">
          <div class="ra-tag" :class="status ? 'success' : 'primary'">
            {{ status ? 'Terminé' : "En cours" }}
          </div>
        </CCol>
        <CCol col="2">
          <Text size="p6" class="ml-7">
            {{ numberOfTickets ? numberOfTickets : "-" }}
          </Text>
        </CCol>
        <CCol class="detail-link" col="3">
          <Text
            color="primary"
            size="p5"
            class="link"
            :link="{
              name: 'Cycle Details',
              params: { ...this.$route.params, cycle },
            }"
            @click="openDetail"
          >
            Open detail
          </Text>
        </CCol>
      </CRow>
    </div>
    <CCollapse v-bind="{ ...$props }" :show="visible">
      <div class="px-3" style>
        <slot></slot>
      </div>
    </CCollapse>
  </div>
</template>

<script>
export default {
  name: 'CycleStatus',
  props: {
    duration: {
      type: [Number, Object],
      default: 400
    },
    cycle: String,
    title: {
      type: String,
      default: ''
    },
    status: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: String,
      default: 'ease-in-out'
    },
    show: {
      type: Boolean,
      default: false,
    },
    numberOfTickets: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      visible: this.show,
    }
  },
  watch: {
    show(val) {
      this.visible = val
    },
  },
  methods: {
    openDetail() {
      this.$emit("open-detail", this.title);
    }
  }
}
</script>
<style lang="scss">
  .cycle-status__wrapper {
    &:hover {
      background-color: #E7F0FA;
    }
  }
  .cycle-title {
    color: #464b4b;
  }
  .detail-link {
    opacity: 0;
    &:hover {
      opacity: 1;
    }
  }

  .card-collapse .ra-icon {
    width: 10px;
  }
</style>
